import ConvertModule from './ConvertContainer';
import {isMobile} from 'Utils/device';
import "./index.scss";
let ConvertModuleFn = (isMobile)? null: ConvertModule;

export default ConvertModuleFn;